/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { Link as ChakraLink, PropsOf } from '@getgo/chameleon-chakra-ui';
import React, { forwardRef } from 'react';

interface LinkOptions {
  textDecoration?: string;
  onHover?: {};
}

export type LinkProps = PropsOf<typeof ChakraLink> & LinkOptions;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const {
    textDecoration = 'none',
    onHover = { textDecoration: 'underline' },
    children,
    ...rest
  } = props;

  return (
    <ChakraLink
      ref={ref}
      {...rest}
      textDecoration={textDecoration}
      _hover={onHover}
    >
      {children}
    </ChakraLink>
  );
});
